// ======= Localisation =======
const translations = {
  fr: {
    welcome: "Bienvenue sur Opella Pledge",
    appDescription: "Application mobile-first pour recueillir vos données et votre signature.",
    accessForm: "Accéder au formulaire",
    formTitle: "Formulaire d'inscription",
    formDescription: "Veuillez renseigner vos informations et signer ci-dessous.",
    nomLabel: "Nom :",
    prenomLabel: "Prénom :",
    emailLabel: "Email :",
    paysLabel: "Pays :",
    signatureLabel: "Signature :",
    clearSignature: "Effacer la signature",
    acceptTerms: "J'accepte les conditions générales",
    sendButton: "Envoyer",
    loaderText: "Envoi en cours...",
    successMessage: "Données envoyées avec succès.",
    errorMessage: "Erreur lors de l'envoi des données.",
    signatureMissing: "Veuillez fournir votre signature.",
    invalidName: "Nom invalide.",
    invalidPrenom: "Prénom invalide.",
    invalidEmail: "Email invalide.",
    invalidPays: "Veuillez sélectionner un pays.",
    invalidAcceptTerms: "Vous devez accepter les conditions générales."
  },
  en: {
    welcome: "Welcome to Opella Pledge",
    appDescription: "Mobile-first application to collect your data and signature.",
    accessForm: "Access the form",
    formTitle: "Registration Form",
    formDescription: "Please fill in your information and sign below.",
    nomLabel: "Last Name:",
    prenomLabel: "First Name:",
    emailLabel: "Email:",
    paysLabel: "Country:",
    signatureLabel: "Signature:",
    clearSignature: "Clear Signature",
    acceptTerms: "I accept the terms and conditions",
    sendButton: "Send",
    loaderText: "Sending...",
    successMessage: "Data sent successfully.",
    errorMessage: "Error sending data.",
    signatureMissing: "Please provide your signature.",
    invalidName: "Invalid last name.",
    invalidPrenom: "Invalid first name.",
    invalidEmail: "Invalid email.",
    invalidPays: "Please select a country.",
    invalidAcceptTerms: "You must accept the terms and conditions."
  },
  es: {
    loaderText: "Enviando...",
    successMessage: "¡Gracias por su participación!",
    errorMessage: "Error al enviar los datos.",
    signatureMissing: "Por favor, proporciona tu firma.",
    invalidTitle: "Por favor, selecciona un título.",
    invalidName: "Apellido no válido.",
    invalidPrenom: "Nombre no válido.",
    invalidEmail: "Correo electrónico no válido.",
    invalidPays: "Por favor, selecciona un país.",
    invalidAcceptTerms: "Debes aceptar los términos y condiciones."    
  }
};

// Déterminer la langue du navigateur (extraction des 2 premiers caractères)
const userLang = (navigator.language || navigator.userLanguage).slice(0, 2);
const lang = "es";//translations[userLang] ? userLang : "fr";

// Fonction de localisation
function localizePage() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (translations[lang] && translations[lang][key]) {
      el.innerText = translations[lang][key];
    }
  });
}
//document.addEventListener('DOMContentLoaded', localizePage);

// ======= Population Dynamique des Pays =======
/*const allCountries = [
  "Afghanistan","Afrique du Sud","Albanie","Algérie","Allemagne","Andorre","Angola","Antigua-et-Barbuda","Arabie Saoudite","Argentine",
  "Arménie","Australie","Autriche","Azerbaïdjan","Bahamas","Bahreïn","Bangladesh","Barbade","Belgique","Belize",
  "Bénin","Bhoutan","Biélorussie","Birmanie","Bolivie","Bosnie-Herzégovine","Botswana","Brésil","Brunei","Bulgarie",
  "Burkina Faso","Burundi","Cambodge","Cameroun","Canada","Cap-Vert","République centrafricaine","Tchad","Chili","Chine",
  "Chypre","Colombie","Comores","Congo (Brazzaville)","Congo (Kinshasa)","Corée du Nord","Corée du Sud","Costa Rica","Côte d’Ivoire","Croatie",
  "Cuba","Danemark","Djibouti","Dominique","Égypte","El Salvador","Émirats arabes unis","Équateur","Érythrée","Espagne",
  "Estonie","États-Unis","Éthiopie","Fidji","Finlande","France","Gabon","Gambie","Géorgie","Ghana",
  "Grèce","Grenade","Guatemala","Guinée","Guinée-Bissau","Guinée équatoriale","Guyana","Haïti","Honduras","Hongrie",
  "Inde","Indonésie","Irak","Iran","Irlande","Islande","Israël","Italie","Jamaïque","Japon",
  "Jordanie","Kazakhstan","Kenya","Kirghizistan","Kiribati","Koweït","Laos","Lesotho","Lettonie","Liban",
  "Libéria","Libye","Liechtenstein","Lituanie","Luxembourg","Macédoine","Madagascar","Malaisie","Malawi","Maldives",
  "Mali","Malte","Îles Marshall","Mauritanie","Maurice","Mexique","Micronésie","Moldavie","Monaco","Mongolie",
  "Monténégro","Maroc","Mozambique","Namibie","Nauru","Népal","Nicaragua","Niger","Nigeria","Norvège",
  "Nouvelle-Zélande","Oman","Ouganda","Ouzbékistan","Pakistan","Palaos","Panama","Papouasie-Nouvelle-Guinée","Paraguay","Pays-Bas",
  "Pérou","Philippines","Pologne","Portugal","Qatar","République dominicaine","Roumanie","Royaume-Uni","Russie","Rwanda",
  "Saint-Christophe-et-Niévès","Sainte-Lucie","Saint-Vincent-et-les-Grenadines","Salomon","Salvador","Samoa","São Tomé-et-Príncipe","Sénégal","Serbie","Seychelles",
  "Sierra Leone","Singapour","Slovaquie","Slovénie","Somalie","Soudan","Soudan du Sud","Sri Lanka","Suède","Suisse",
  "Suriname","Swaziland","Syrie","Tadjikistan","Tanzanie","Tchécoslovaquie (historique)","Thaïlande","Timor oriental","Togo","Tonga",
  "Trinité-et-Tobago","Tunisie","Turkménistan","Turquie","Tuvalu","Ukraine","Uruguay","Vanuatu","Vatican","Venezuela","Viêt Nam",
  "Yémen","Zambie","Zimbabwe"
];
const prioritizedCountries = ["Colombie", "Costa Rica"];
*/

let allCountries = [
  "Afganistán",
  "Sudáfrica",
  "Albania",
  "Argelia",
  "Alemania",
  "Andorra",
  "Angola",
  "Antigua y Barbuda",
  "Arabia Saudita",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Baréin",
  "Bangladesh",
  "Barbados",
  "Bélgica",
  "Belice",
  "Benín",
  "Bután",
  "Bielorrusia",
  "Birmania",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botsuana",
  "Brasil",
  "Brunéi",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Camboya",
  "Camerún",
  "Canadá",
  "Cabo Verde",
  "República Centroafricana",
  "Chad",
  "Chile",
  "China",
  "Chipre",
  "Colombia",
  "Comoras",
  "Congo (Brazzaville)",
  "Congo (Kinshasa)",
  "Corea del Norte",
  "Corea del Sur",
  "Costa Rica",
  "Costa de Marfil",
  "Croacia",
  "Cuba",
  "Dinamarca",
  "Yibuti",
  "Dominica",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Ecuador",
  "Eritrea",
  "España",
  "Estonia",
  "Estados Unidos",
  "Etiopía",
  "Fiyi",
  "Finlandia",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Grecia",
  "Granada",
  "Guatemala",
  "Guinea",
  "Guinea-Bisáu",
  "Guinea Ecuatorial",
  "Guyana",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Islandia",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguistán",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Lesoto",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Macedonia",
  "Madagascar",
  "Malasia",
  "Malaui",
  "Maldivas",
  "Malí",
  "Malta",
  "Islas Marshall",
  "Mauritania",
  "Mauricio",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montenegro",
  "Marruecos",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Noruega",
  "Nueva Zelanda",
  "Omán",
  "Uganda",
  "Uzbekistán",
  "Pakistán",
  "Palaos",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paraguay",
  "Países Bajos",
  "Perú",
  "Filipinas",
  "Polonia",
  "Portugal",
  "Catar",
  "República Dominicana",
  "Rumanía",
  "Reino Unido",
  "Rusia",
  "Ruanda",
  "San Cristóbal y Nieves",
  "Santa Lucía",
  "San Vicente y las Granadinas",
  "Islas Salomón",
  "El Salvador", // Se répète pour rester cohérent avec la liste originale
  "Samoa",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Eslovaquia",
  "Eslovenia",
  "Somalia",
  "Sudán",
  "Sudán del Sur",
  "Sri Lanka",
  "Suecia",
  "Suiza",
  "Surinam",
  "Suazilandia", // Nombre oficial más reciente: Esuatini
  "Siria",
  "Tayikistán",
  "Tanzania",
  "Checoslovaquia (histórico)",
  "Tailandia",
  "Timor Oriental",
  "Togo",
  "Tonga",
  "Trinidad y Tobago",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uruguay",
  "Vanuatu",
  "Vaticano",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabue"
];

allCountries.sort();

const prioritizedCountries = [
  "Colombia",
  "Costa Rica"
];

const allTitles = [
  "Dra",
  "Dr",
  "Prof."
];

function populateCountries() {
  const select = document.getElementById('pays');
  if (!select) return;
  const sortedCountries = allCountries.sort((a, b) => a.localeCompare(b, lang));
  const remainingCountries = sortedCountries.filter(c => !prioritizedCountries.includes(c));
  const finalList = [...prioritizedCountries, ...remainingCountries];
  finalList.forEach(country => {
    const option = document.createElement('option');
    option.value = country;
    option.innerText = country;
    select.appendChild(option);
  });
}
document.addEventListener('DOMContentLoaded', populateCountries);

function populateTitles() {
  const select = document.getElementById('titre');
  if (!select) return;
  allTitles.forEach(title => {
    const option = document.createElement('option');
    option.value = title;
    option.innerText = title;
    select.appendChild(option);
  });
}
document.addEventListener('DOMContentLoaded', populateTitles);

// ======= Désactiver/Réactiver le scroll global =======
function disableScroll() {
  document.body.style.overflow = 'hidden';
}
function enableScroll() {
  document.body.style.overflow = '';
}

// ======= Fonctions d'Affichage (Loader, Popup) =======
function showLoader(show) {
  const overlay = document.getElementById('loaderOverlay');
  if (overlay) {
    overlay.style.display = show ? "flex" : "none";
  }
  if (show) {
    disableScroll();
  } else {
    enableScroll();
  }
}
function showPopup(message) {
  const popupModal = document.getElementById('popupModal');
  const popupMessage = document.getElementById('popupMessage');
  popupMessage.innerText = message;
  popupModal.style.display = "flex";
  disableScroll();
}

let closePopup = document.getElementById('closePopup');
if(closePopup){
  closePopup.addEventListener('click', () => {
    document.getElementById('popupModal').style.display = "none";
    enableScroll();
  });
}


// ======= Validation & Soumission du Formulaire (x-www-form-urlencoded) =======
const form = document.getElementById('pledgeForm');
if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const regexName = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
    const regexEmail = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;

    const titre = document.getElementById('titre').value;
    const nom = document.getElementById('nom').value.trim();
    const prenom = document.getElementById('prenom').value.trim();
    const email = document.getElementById('email').value.trim();
    const pays = document.getElementById('pays').value;
    const sign = document.getElementById('sign').checked;
    const acceptTerms = document.getElementById('acceptTerms').checked;

    // Validation
    if (!regexName.test(nom)) { showPopup(translations[lang].invalidName); return; }
    if (titre === "") { showPopup(translations[lang].invalidTitre); return; }
    if (!regexName.test(prenom)) { showPopup(translations[lang].invalidPrenom); return; }
    if (!regexEmail.test(email)) { showPopup(translations[lang].invalidEmail); return; }
    if (pays === "") { showPopup(translations[lang].invalidPays); return; }
    if (!sign) { showPopup(translations[lang].signatureMissing); return; }
    if (!acceptTerms) { showPopup(translations[lang].invalidAcceptTerms); return; }

    showLoader(true);

    const params = new URLSearchParams();
    params.append('titre', titre);
    params.append('nom', nom);
    params.append('prenom', prenom);
    params.append('email', email);
    params.append('pays', pays);
    params.append('signature', sign);
    params.append('acceptTerms', acceptTerms);

    console.log(params.toString());

    fetch('https://script.google.com/macros/s/AKfycbw_0PIPPlLDIxaJyOhjthe1bDtx0hpxX_UYDXkpzko1AUpty6xT2sC2szg5z6QylIfKFg/exec', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    })
    .then(response => response.json())
    .then(result => {
      showLoader(false);
      if (result.success) {
        showPopup(translations[lang].successMessage);
        form.reset();
      } else {
        showPopup(translations[lang].errorMessage);
      }
    })
    .catch(error => {
      console.error('Erreur:', error);
      showLoader(false);
      showPopup(translations[lang].errorMessage);
    });
  });
}

  function updateCounter(localUpdate) {
    if(localUpdate){
      let localPladgeCount = localStorage.getItem("daad::pledgeCount") || "0";
      displayCounter(localPladgeCount);
    }
    else {
      fetch('https://script.google.com/macros/s/AKfycbyLiQzDok06Vw7NqA-GxXot-7gn-VK60vuOUe7Q-dFjUU6pwkoGLepP47dNx-WQTGyk-A/exec?method=pledgeCount')
      .then(response => response.json())
      .then(data => {
        console.log('data:', data);
        const count = data.pledgeCount;
        displayCounter(count);
      })
      .catch(error => {
        console.error('Error fetching counter:', error);
      });
    }    
  }

  function displayCounter(value){
    localStorage.setItem("daad::pledgeCount", value);
    const countStr = String(value).padStart(4, '0');
    document.querySelector('.counter-container').classList.remove("faded");
    const symbols = document.querySelectorAll('.counter-symbol');
    symbols.forEach((elem, index) => {
      elem.innerText = countStr.charAt(index) || '';
    });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    if(null != document.querySelector('.counter-container')){
      updateCounter(true);
      updateCounter();
      setInterval(updateCounter, 30000);
    }
  });